export function domainIdForHighlight(
  domains: Array<{ id: string; skill_ids?: string[] }>,
  highlightKey: string | null | undefined,
): string | null {
  const key = highlightKey?.trim()
  if (!key) return null
  if (key.startsWith('domain:')) {
    const id = key.slice('domain:'.length)
    return domains.some((domain) => domain.id === id) ? id : null
  }
  if (key.startsWith('skill:')) {
    const skillId = key.slice('skill:'.length)
    const match = domains.find((domain) => domain.skill_ids?.includes(skillId))
    return match?.id ?? null
  }
  return null
}
